export default "__VITE_ASSET__Cjz0juN___"